import { createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-items-end" }
const _hoisted_2 = {
  key: 0,
  class: "text-end mb-2"
}
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = { class: "countdown-message" }
const _hoisted_5 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_6 = {
  key: 1,
  class: "text-end mb-2"
}
const _hoisted_7 = { class: "text-muted" }
const _hoisted_8 = { class: "countdown-message" }
const _hoisted_9 = {
  key: 2,
  class: "text-end mb-2"
}
const _hoisted_10 = { class: "text-danger" }
const _hoisted_11 = {
  key: 3,
  class: "text-end mb-2"
}
const _hoisted_12 = { class: "text-warning" }
const _hoisted_13 = { class: "d-flex gap-2" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_17 = {
  key: 1,
  class: "fas fa-plus me-2"
}
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_20 = {
  key: 1,
  class: "fas fa-save me-2"
}

import { computed, inject, toRef } from "vue";
import VueCountdown from "@chenfengyuan/vue-countdown";
import BookingCountdownText from "./BookingCountdownText.vue";
import { bookingFormContextKey } from "./bookingFormContext.js";
import { useBookingModificationWindow } from "../../composables/useBookingModificationWindow.js";


export default {
  __name: 'BookingFormActions',
  props: {
	booking: { type: Object, default: null },
	show: { type: Boolean, default: false },
	isLoading: { type: Boolean, default: false },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const formContext = inject(bookingFormContextKey);
if (!formContext) {
	throw new Error("BookingFormActions requires bookingFormContext");
}

const { userRole, timeRestricted, editCountdownConfig, shouldShowEditModeCountdown, handleEditCountdownExpired } =
	useBookingModificationWindow({
		booking: toRef(props, "booking"),
		show: toRef(props, "show"),
	});

const isEditMode = computed(() =>
	["edit", "edit-series", "edit-instance"].includes(formContext.mode)
);

const showEditCountdown = computed(() =>
	shouldShowEditModeCountdown(formContext.mode)
);

const showCreateCountdown = computed(() => {
	if (!["create", "edit", "edit-series", "edit-instance"].includes(formContext.mode)) {
		return false;
	}

	const constraint = formContext.currentCreationConstraint;
	return (
		userRole.value === "student" &&
		constraint?.showCountdown &&
		(constraint?.reason === "warning_window" || constraint?.reason === "too_far") &&
		!!formContext.startDateTime
	);
});

const updateButtonText = computed(() => {
	switch (formContext.mode) {
		case "edit-series":
			return "Serie aktualisieren";
		case "edit-instance":
			return "Einzeltermin aktualisieren";
		default:
			return "Buchung aktualisieren";
	}
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Edit time constraint countdown "),
    (showEditCountdown.value && _unref(editCountdownConfig))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("small", _hoisted_3, [
            (_unref(editCountdownConfig).time > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(editCountdownConfig).message), 1 /* TEXT */),
                  _createVNode(_unref(VueCountdown), {
                    time: _unref(editCountdownConfig).time,
                    onEnd: _unref(handleEditCountdownExpired)
                  }, {
                    default: _withCtx((timeLeft) => [
                      _createVNode(BookingCountdownText, _mergeProps(timeLeft, {
                        "text-class": `text-${_unref(editCountdownConfig).warningLevel}`
                      }), null, 16 /* FULL_PROPS */, ["text-class"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["time", "onEnd"])
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("i", { class: "fas fa-exclamation-triangle me-1" }, null, -1 /* CACHED */),
                  _createTextVNode(" Bearbeitung und Löschung nicht mehr möglich ", -1 /* CACHED */)
                ]))]))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Creation time constraint countdown "),
    (showCreateCountdown.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("small", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(formContext).currentCreationConstraint.message), 1 /* TEXT */),
            (_unref(formContext).currentCreationConstraint.msRemaining > 0)
              ? (_openBlock(), _createBlock(_unref(VueCountdown), {
                  key: 0,
                  time: _unref(formContext).currentCreationConstraint.msRemaining,
                  onEnd: _cache[0] || (_cache[0] = $event => (_unref(formContext).refreshCreationConstraints()))
                }, {
                  default: _withCtx((timeLeft) => [
                    _createVNode(BookingCountdownText, _mergeProps(timeLeft, { "text-class": "text-info" }), null, 16 /* FULL_PROPS */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["time"]))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Hard creation restriction (no countdown) "),
    (
        _unref(formContext).isCreationTimeRestricted &&
          _unref(formContext).currentCreationConstraint?.message &&
          !_unref(formContext).currentCreationConstraint?.showCountdown
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("small", _hoisted_10, [
            _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-1" }, null, -1 /* CACHED */)),
            _createTextVNode(" " + _toDisplayString(_unref(formContext).currentCreationConstraint.message), 1 /* TEXT */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Near-deadline warning "),
    (_unref(formContext).creationDeadlineWarning?.showWarning)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("small", _hoisted_12, [
            _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-1" }, null, -1 /* CACHED */)),
            _createTextVNode(" " + _toDisplayString(_unref(formContext).creationDeadlineWarning.message), 1 /* TEXT */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        disabled: __props.isLoading,
        onClick: _cache[1] || (_cache[1] = $event => (emit('close')))
      }, " Abbrechen ", 8 /* PROPS */, _hoisted_14),
      (_unref(formContext).mode === 'create')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-primary",
            disabled: 
          __props.isLoading ||
            !_unref(formContext).isFormValid ||
            !_unref(formContext).hasFormChanged ||
            _unref(formContext).isCreationTimeRestricted
        ,
            onClick: _cache[2] || (_cache[2] = $event => (_unref(formContext).submit()))
          }, [
            (__props.isLoading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16))
              : (_openBlock(), _createElementBlock("i", _hoisted_17)),
            _createTextVNode(" " + _toDisplayString(_unref(formContext).isWalkIn
            ? "Sofortbuchung erstellen"
            : "Buchung erstellen"), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_15))
        : (isEditMode.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn-primary",
              disabled: 
          __props.isLoading ||
            !_unref(formContext).isFormValid ||
            !_unref(formContext).hasFormChanged ||
            (_unref(timeRestricted) && _unref(userRole) === 'student') ||
            _unref(formContext).isCreationTimeRestricted
        ,
              onClick: _cache[3] || (_cache[3] = $event => (_unref(formContext).submit()))
            }, [
              (__props.isLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19))
                : (_openBlock(), _createElementBlock("i", _hoisted_20)),
              _createTextVNode(" " + _toDisplayString(updateButtonText.value), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_18))
          : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

}